import $ from 'jquery';
import { lory } from 'lory.js';

export default class HomeNews {
  static init() {
    this.$section = $('.magazine-home');

    if (this.$section.length <= 0) {
      return;
    }

    this.$nextArrow = this.$section.find('.arrow-btn.next');
    this.$previousArrow = this.$section.find('.arrow-btn.previous');

    this.$newsroomCarousel = this.$section.find('.home-articles-carousel');

    const loryOptions = {
      infinite: false,
      rewind: true,
      slidesToScroll: 1,
      enableMouseEvents: false,
      slideSpeed: 500,
    };

    // this.$newsroomCarousel[0].addEventListener('after.lory.slide', (event) => {
    //   console.log(event.detail);
    //   if (event.detail.currentSlide === 0) {
    //     this.$previousArrow.addClass('js-disabled');
    //   } else {
    //     this.$previousArrow.removeClass('js-disabled');
    //   }

    //   if (event.detail.currentSlide === 0) {
    //     this.$previousArrow.addClass('js-disabled');
    //   } else {
    //     this.$previousArrow.removeClass('js-disabled');
    //   }
    // });
    // this.$newsroomCarousel[0].addEventListener('after.lory.init', (event) => {
    //   console.log(event);
    // });

    this.newsroomLory = lory(this.$newsroomCarousel[0], loryOptions);

    this.$nextArrow.on('click', (event) => {
      event.preventDefault();
      this.onNextClick();
    });

    this.$previousArrow.on('click', (event) => {
      event.preventDefault();
      this.onPreviousClick();
    });
  }

  static onNextClick() {
    this.newsroomLory.next();
  }

  static onPreviousClick() {
    this.newsroomLory.prev();
  }
}



// WEBPACK FOOTER //
// ./assets/js/components/home-news.js